// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';

import { Button } from 'reshaped';

import { approveContract, selectContracts } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

export function ContractsButton(): React.MixedElement {
  const dispatch = useDispatch();
  const { __ } = useTranslator();
  const contracts = useAppSelector(selectContracts);

  const allContractsApproved = contracts.every(contract => contract.isApproved);

  const handleToggleAllContracts =
    (isApproved: boolean) => (evt: SyntheticEvent<>) => {
      evt.preventDefault();

      contracts.forEach(contract => {
        dispatch(
          approveContract({ identifier: contract.identifier, isApproved }),
        );
      });
    };

  return allContractsApproved ? (
    <Button variant="ghost" onClick={handleToggleAllContracts(false)}>
      {__('Review')}
    </Button>
  ) : (
    <Button color="primary" onClick={handleToggleAllContracts(true)}>
      {__('Accept All')}
    </Button>
  );
}
